import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { AccessManagementView } from "./accessManagement-view"

export class AccessManagementViewModel extends WindowViewModel{
    public getTitle(): string {
        return "تنظیم دسترسی";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.users = ObservableArray.create<User>();
        this.forms = ObservableArray.create<UiForm>();
        this.refresh();
        
    }
    GetDefaultView(): View <ViewModel> {
        return new AccessManagementView();
    }
    public getTypeId(): string {
        return "VM-18A1A19B-41B7-46E0-A921-CB5609101369"
    }

    public set users(v: ObservableArray<User>) { this._users = v; } public get users(): ObservableArray<User> { return this._users;} private _users: ObservableArray<User>;
    public set forms(v: ObservableArray<UiForm>) { this._forms = v; } public get forms(): ObservableArray<UiForm> { return this._forms;} private _forms: ObservableArray<UiForm>;
    public set selectedUser(v: User) { this._selectedUser = v; } public get selectedUser(): User { return this._selectedUser;} private _selectedUser: User;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectAll(v: boolean) { 
        this._selectAll = v; 
        if (v)
            this.forms.forEach(x => x.hasAccess = true);
        else
            this.forms.forEach(x => x.hasAccess = false);
    }
    public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;


    async refresh(){
        try {
            this.isLoading = true;
            await Promise.all([this.loadAllUsers(),this.loadAllForms()]);        
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async loadAllUsers(){
        let result = await ServerConnection.callServer('/Complex/AuthenticationServices/GetAllUsers',{});
        this.users.update(...result.Users.map(q=>{
            let r = new User(this);
            r.userId = q.Id;
            r.username = q.Username;
            r.setPersonnelIdentificationInfo(q.PersonnelName,q.PersonnelLastName);
            r.isSelected = false;
            return r;
        }))
    }
    async loadAllForms(){
        let result = await ServerConnection.callServer('/Complex/AuthenticationServices/GetAllForms',{})
        this.forms.update(...result.Forms.map((q,i)=>{
            let fullName:string = q.Name
            let r = new UiForm(this);
            r.rowNumber = i+1;
            r.id = q.Id;
            r.prefix = fullName.split('/')[0];
            r.formName = fullName.split('/')[1];
            r.hasAccess = false;
            return r;
        }))
    }  
    
    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/AuthenticationServices/SetUserAccesses', {
                UserId: this.selectedUser.userId,
                AllowedForms: this.forms.filter(x => x.hasAccess == true).map(x => x.id)
            });
            let a = 0;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async getAccessibleForms() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/AuthenticationServices/GetAccessibleForms', {UserId:this.selectedUser.userId});
            let accessibleForms = result.Forms.map(x=>x.Id);
            this.forms.forEach(element => {
                if (accessibleForms.includes(element.id)){
                    element.hasAccess = true;
                }else{
                    element.hasAccess = false
                }
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    selectUser(user: User) {
        this.users.forEach(x=>x.isSelected = false);
        user.isSelected = true;
        this.selectedUser = user;
        this.getAccessibleForms();
    }
    

}

export class User extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:AccessManagementViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : AccessManagementViewModel;
    public set userId(v: string) { this._userId = v; } public get userId(): string { return this._userId;} private _userId: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelLastName(v: string) { this._personnelLastName = v; } public get personnelLastName(): string { return this._personnelLastName;} private _personnelLastName: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    

    requestSelection(){
        this._typedParent.selectUser(this);
        
    }

    setPersonnelIdentificationInfo(name: any, lastName: any) {
        this.personnelName = name;
        this.personnelLastName = lastName;
        this.personnelFullName =`${this.personnelName?? ''} ${this.personnelLastName?? ''}`;
    }
    
}

export class UiForm extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:AccessManagementViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: AccessManagementViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set prefix(v: string) { this._prefix = v; } public get prefix(): string { return this._prefix;} private _prefix: string;
    public set formName(v: string) { this._formName = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set hasAccess(v: boolean) { this._hasAccess = v; } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    
    
}